export default "__VITE_ASSET__DjGE0QlQ__"